import React from 'react'
import { IPropsTickets, ISellCreditTicket } from '../utils/interfaceTickets'
import { setearMiles } from 'util/funciones'

const PaymentMeans = ({ data }: IPropsTickets) => {

    let newData = data as ISellCreditTicket

    return (
        <>
            <table>
                <thead>
                    <tr>
                        <th className="receipt__table__header text__bold" style={{ width: '35%' }}>MEDIO DE PAGO</th>
                        <th className="receipt__table__header text__bold" style={{ width: '35%' }}>AUTORIZACION</th>
                        <th className="receipt__table__header text__bold" style={{ width: '30%' }}>TOTAL</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="receipt__table__cell text__ellipsis w__ellipsis__medium">{newData.metodo_pago}</td>
                        <td className="receipt__table__cell text__ellipsis w__ellipsis__medium">{newData.codigo_autorizacion}</td>
                        <td className="receipt__table__cell text__ellipsis w__ellipsis__medium">${setearMiles(newData.valor_venta_total)}</td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}

export default PaymentMeans